<template>
  <div class="main_view">
    <!--导航栏-->
    <div class="report_head">
      <div class="report_head_item">
        <div class="report_head_left">
          <div class="report_info">
            <a href="/#/" target="_blank">
              <img src="/static/images/bigdata/maoyan_logo.png"/>
            </a>
          </div>
          <div class="line"></div>
          <div class="note">
            <span>小红书AI智能投放分析：<span style="color: #396AF2; font-weight: bolder">【{{keyWord}}】</span></span>
          </div>
        </div>
        <div class="report_head_right">
          <div class="item_right"  @mouseover="logoutOver" @mouseout="logoutOut">
            <img class="img_head" src="/static/images/bigdata/brand_head_icon.png"/>
            <div class="nick_name">{{nickName}}</div>
            <div class="logout" v-show="showLogin" @click="clickLogout">退 出 登 录</div>
          </div>
        </div>
      </div>
    </div>
    <!--切换栏-->
    <div class="report_home">
      <div class="shop">
        <div class="report_list">
          <div class="report_item_head">
            <div class="report_item_value" v-for="(headItem, headItemIndex) in headItems"
                 :key="headItemIndex" :class="{'selected' : headIndex === headItemIndex }" @click="clickHeadItem(headItemIndex)">{{headItem}}</div>
          </div>
        </div>
      </div>
    </div>

    <!--数据概览-->
    <div class="report_item">
      <div class="head_item">
        <span>笔记数据概览</span>
      </div>
      <div class="report show_item">
        <div class="show_child_item" v-for="(result, resultIndex) in guideLists">
          <span class="name">{{result.value}}</span>
          <span class="note">{{result.title}}</span>
        </div>
      </div>
    </div>

    <div class="report_echarts_double">
      <!--echarts柱状图 笔记发布数量分布-->
      <div class="report_echarts_one">
        <div class="echarts_head">
          <span>笔记发布数分布图</span>
        </div>
        <div class="echarts_map" ref="bar_chart_publish">
        </div>
      </div>
      <!--echarts柱状图 笔记互动数量分布-->
      <div class="report_echarts_two">
        <div class="echarts_head">
          <span>笔记互动数分布图</span>
        </div>
        <div class="echarts_map" ref="bar_chart_interact">
        </div>
      </div>
    </div>
    <!--echarts饼状图 合作类型 笔记类型-->
    <div class="report_trend">
      <div class="report_echarts_one">
        <div class="echarts_head">
          <span>合作类型</span>
        </div>
        <div class="echarts_map" ref="pie_chart_coop">
        </div>
      </div>
      <div class="report_echarts_two">
        <div class="echarts_head">
          <span>笔记类型</span>
        </div>
        <div class="echarts_map" ref="pie_chart_type"></div>
      </div>
    </div>
    <!--echarts折线图 笔记数量-->
    <div class="report_echarts">
      <div class="echarts_head">
        <span>笔记发布数趋势图</span>
      </div>
      <div class="echarts_map" ref="line_chart_note">
      </div>
    </div>
    <!--echarts折线图 笔记互动数量-->
    <div class="report_echarts">
      <div class="echarts_head">
        <span>笔记互动数趋势图</span>
      </div>
      <div class="echarts_map" ref="line_chart_note_interact">
      </div>
    </div>
    <!--echarts饼状图 笔记内容舆情 笔记评论舆情-->
    <div class="report_trend">
      <div class="report_echarts_one">
        <div class="echarts_head">
          <span>笔记内容舆情</span>
        </div>
        <div class="echarts_map" ref="pie_chart_content">
        </div>
      </div>
      <div class="report_echarts_two">
        <div class="echarts_head">
          <span>笔记评论舆情</span>
        </div>
        <div class="echarts_map" ref="pie_chart_comment"></div>
      </div>
    </div>
    <!--echarts词云图 笔记标题词云 笔记评论词云-->
    <div class="report_trend">
      <div class="report_echarts_one">
        <div class="echarts_head">
          <span>笔记标题词云</span>
        </div>
        <div class="echarts_map" ref="word_chart_title">
        </div>
      </div>
      <div class="report_echarts_two">
        <div class="echarts_head">
          <span>笔记评论词云</span>
        </div>
        <div class="echarts_map" ref="word_chart_comment"></div>
      </div>
    </div>
    <!--echarts词云图 笔记内容词云-->
    <div class="report_echarts">
      <div class="echarts_head">
        <span>笔记内容词云</span>
      </div>
      <div class="echarts_map" ref="word_chart_content">
      </div>
    </div>
    <!--echarts词云图 笔记位置词云-->
    <div class="report_echarts">
      <div class="echarts_head">
        <span>笔记位置词云</span>
      </div>
      <div class="echarts_map" ref="word_chart_poi">
      </div>
    </div>
    <!--底部导航-->
<!--    <div  class="bottom_div">COPYRIGHT  2020-2023 杭州袤周云计算有限公司<a rel="nofollow" href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2022031665号</a></div>-->
  </div>
</template>

<script>
import * as echarts from 'echarts';
import 'echarts-wordcloud';
import process from "shelljs";
export default {
  name: "BigdataNote",
  data() {
    return {
      showLogin: false,
      nickName: this.$cookies.get('UserName') || '演示账号',
      keyWord: this.$cookies.get('KeyWord'),
      headIndex: 1,
      headItems: ['达人分析', '笔记分析', '达人列表', '笔记列表', '爆文分析', '报备分析'],
      guideLists: [],
    }
  },
  methods: {
    clickHeadItem (headIndex) {
      // 跳转
      if (headIndex === 0) {
        this.$router.push('/bigdata')
      }
      if (headIndex === 2) {
        this.$router.push('/kollist')
      }
      if (headIndex === 3) {
        this.$router.push('/notelist')
      }
      if (headIndex === 4) {
        this.$router.push('/notehot')
      }
      if (headIndex === 5) {
        this.$router.push('/notebaobei')
      }
    },
    clickLogout () {
      // 本地保存token
      this.$cookies.remove("UserToken");
      this.$cookies.remove("UserName");
      // 跳转
      this.$router.push('/login');
    },
    logoutOver () {
      this.showLogin = true;
    },
    logoutOut () {
      this.showLogin = false;
    },
    getListData() {
      let base = '/api';
      if (process.env.NODE_ENV === "development") {
        base = 'http://api.wushangxianzhi.com';
      }
      let url = '/api/v2/maocep/maocep_vue_xhs_echarts_notes';
      //数据请求 HTTP_AUTHORIZATION
      this.$axios.defaults.headers.common['Authorization'] = this.$cookies.get('UserToken')
      this.$axios({
        method: 'post',
        url: `${base}${url}`,
        responseType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
          'keyword': this.$cookies.get('KeyWord')
        })
      }).then((res) => {
        console.log("res ", res);
        // ===数据概览===
        let guidedata = res.data.result[0].guide_data;
        let guide_dic1 = { title: '笔记总数', value: guidedata.note_counts};
        let guide_dic2 = { title: '点赞总数', value: guidedata.like_note_counts};
        let guide_dic3 = { title: '评论总数', value: guidedata.comment_note_counts};
        let guide_dic4 = { title: '收藏总数', value: guidedata.collect_note_counts};
        this.guideLists = [guide_dic1, guide_dic2, guide_dic3, guide_dic4];
        // ===柱状图===
        let bardata = res.data.result[0].bar_data;
        // 笔记发布数量
        let baroption_publish = {
          tooltip: {
            show: true,
            trigger: 'axis'
          },
          xAxis: {
            type: 'category',
            data: bardata.notes_publish.x_names,
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: bardata.notes_publish.y_vales,
              type: 'bar',
              barWidth: 50,
              smooth: true,
              color: '#396AF2'
            }
          ]
        }
        let barchart_publish = echarts.init(this.$refs.bar_chart_publish);
        barchart_publish.setOption(baroption_publish);
        // 笔记互动数量
        let baroption_interact = {
          tooltip: {
            show: true,
            trigger: 'axis'
          },
          xAxis: {
            type: 'category',
            data: bardata.notes_interact.x_names,
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: bardata.notes_interact.y_vales,
              type: 'bar',
              barWidth: 50,
              smooth: true,
              color: '#396AF2'
            }
          ]
        }
        let barchart_interact = echarts.init(this.$refs.bar_chart_interact);
        barchart_interact.setOption(baroption_interact)
        // ===饼状图===
        // 合作类型
        let piedata = res.data.result[0].pie_data;
        let peidata_coop = [];
        for(let i = 0; i　< piedata.note_coop.x_names.length; i++) {
          let ndic = { name: piedata.note_coop.x_names[i], value: piedata.note_coop.y_vales[0][i]};
          peidata_coop.push(ndic);
        }
        let pieoption_coop = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            top: '10%',
            left: 'center'
          },
          color: ['#396AF2', '#F5a20A', '#F52c9b', '#52C1D0', '#F23939'],
          series: [
            {
              name: piedata.note_coop.y_names[0],
              type: 'pie',
              top: '20%',
              radius: '50%',
              data: peidata_coop,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
        let piechart_coop = echarts.init(this.$refs.pie_chart_coop);
        piechart_coop.setOption(pieoption_coop);
        // 笔记类型
        let peidata_type = [];
        for(let i = 0; i　< piedata.note_type.x_names.length; i++) {
          let ndic = { name: piedata.note_type.x_names[i], value: piedata.note_type.y_vales[0][i]};
          peidata_type.push(ndic);
        }
        let pieoption_type = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            top: '10%',
            left: 'center'
          },
          color: ['#396AF2', '#F5a20A', '#F52c9b', '#52C1D0', '#F23939'],
          series: [
            {
              name: piedata.note_type.y_names[0],
              type: 'pie',
              top: '20%',
              radius: '50%',
              data: peidata_type,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
        let piechart_type = echarts.init(this.$refs.pie_chart_type);
        piechart_type.setOption(pieoption_type);
        // 内容舆情
        let peidata_content = [];
        for(let i = 0; i　< piedata.note_content_sentiment.x_names.length; i++) {
          let ndic = { name: piedata.note_content_sentiment.x_names[i], value: piedata.note_content_sentiment.y_vales[0][i]};
          peidata_content.push(ndic);
        }
        let pieoption_content = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            top: '10%',
            left: 'center'
          },
          color: ['#396AF2', '#F5a20A', '#F52c9b', '#52C1D0', '#F23939'],
          series: [
            {
              name: piedata.note_content_sentiment.y_names[0],
              type: 'pie',
              top: '20%',
              radius: '50%',
              data: peidata_content,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
        let piechart_content = echarts.init(this.$refs.pie_chart_content);
        piechart_content.setOption(pieoption_content);
        // 评论舆情
        let peidata_comment = [];
        for(let i = 0; i　< piedata.note_comment_sentiment.x_names.length; i++) {
          let ndic = { name: piedata.note_comment_sentiment.x_names[i], value: piedata.note_comment_sentiment.y_vales[0][i]};
          peidata_comment.push(ndic);
        }
        let pieoption_comment = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            top: '10%',
            left: 'center'
          },
          color: ['#396AF2', '#F5a20A', '#F52c9b', '#52C1D0', '#F23939'],
          series: [
            {
              name: piedata.note_comment_sentiment.y_names[0],
              type: 'pie',
              top: '20%',
              radius: '50%',
              data: peidata_comment,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
        let piechart_comment = echarts.init(this.$refs.pie_chart_comment);
        piechart_comment.setOption(pieoption_comment);
        // ===折线图===
        let linedata = res.data.result[0].line_data;
        // 笔记发布数
        let lineoption_note = {
          tooltip: {
            show: true,
            trigger: 'axis',
          },
          legend: {
            top: '10%',
            left: 'center',
            data: ['发布笔记数', '视频笔记数', '商业笔记数']
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: linedata.pub_dates,
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '发布笔记数',
              showSymbol: false,
              areaStyle: {},
              data: linedata.pub_notes,
              type: 'line',
              color: '#396AF2'
            },
            {
              name: '视频笔记数',
              showSymbol: false,
              areaStyle: {},
              data: linedata.pub_video_notes,
              type: 'line',
              color: '#F5a20A'
            },
            {
              name: '商业笔记数',
              showSymbol: false,
              areaStyle: {},
              data: linedata.pub_coop_notes,
              type: 'line',
              color: '#52C1D0'
            }
          ]
        }
        let linechart_note = echarts.init(this.$refs.line_chart_note);
        linechart_note.setOption(lineoption_note);
        // 笔记互动数
        let lineoption_note_interact = {
          tooltip: {
            show: true,
            trigger: 'axis',
          },
          legend: {
            top: '10%',
            left: 'center',
            data: ['点赞数', '评论数', '收藏数']
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: linedata.pub_dates,
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '点赞数',
              showSymbol: false,
              areaStyle: {},
              data: linedata.pub_like_notes,
              type: 'line',
              color: '#396AF2'
            },
            {
              name: '评论数',
              showSymbol: false,
              areaStyle: {},
              data: linedata.pub_comment_notes,
              type: 'line',
              color: '#F5a20A'
            },
            {
              name: '收藏数',
              showSymbol: false,
              areaStyle: {},
              data: linedata.pub_collect_notes,
              type: 'line',
              color: '#52C1D0'
            }
          ]
        }
        let linechart_note_interact = echarts.init(this.$refs.line_chart_note_interact);
        linechart_note_interact.setOption(lineoption_note_interact);
        // ===词云图===
        let worddata = res.data.result[0].wordcloud_data;
        // 标题词云
        let wordata_title = [];
        for(let i = 0; i　< worddata.note_title_keywords.x_names.length; i++) {
          let ndic = { name: worddata.note_title_keywords.x_names[i], value: worddata.note_title_keywords.y_vales[0][i]};
          wordata_title.push(ndic);
        }
        let wordoption_title = {
          series: [
            {
              data: wordata_title,
              type: 'wordCloud',
              shape: "smooth",
              textStyle:  {
                color() {
                  let colors = ['#396AF2', '#F5a20A', '#F52c9b', '#52C1D0', '#F23939']
                  return colors[parseInt(Math.random() * 5)]
                }
              },
            }
          ]
        }
        let wordchart_title = echarts.init(this.$refs.word_chart_title);
        wordchart_title.setOption(wordoption_title);
        // 评论词云
        let wordata_comment = [];
        for(let i = 0; i　< worddata.note_comment_keywords.x_names.length; i++) {
          let ndic = { name: worddata.note_comment_keywords.x_names[i], value: worddata.note_comment_keywords.y_vales[0][i]};
          wordata_comment.push(ndic);
        }
        let wordoption_comment = {
          series: [
            {
              data: wordata_comment,
              type: 'wordCloud',
              shape: "smooth",
              textStyle:  {
                color() {
                  let colors = ['#396AF2', '#F5a20A', '#F52c9b', '#52C1D0', '#F23939']
                  return colors[parseInt(Math.random() * 5)]
                }
              },
            }
          ]
        }
        let wordchart_comment = echarts.init(this.$refs.word_chart_comment);
        wordchart_comment.setOption(wordoption_comment);
        // 内容词云
        let wordata_content = [];
        for(let i = 0; i　< worddata.note_content_keywords.x_names.length; i++) {
          let ndic = { name: worddata.note_content_keywords.x_names[i], value: worddata.note_content_keywords.y_vales[0][i]};
          wordata_content.push(ndic);
        }
        let wordoption_content = {
          series: [
            {
              data: wordata_content,
              type: 'wordCloud',
              shape: "smooth",
              sizeRange: [25, 80],
              textStyle:  {
                color() {
                  let colors = ['#396AF2', '#F5a20A', '#F52c9b', '#52C1D0', '#F23939']
                  return colors[parseInt(Math.random() * 5)]
                }
              },
            }
          ]
        }
        let wordchart_content = echarts.init(this.$refs.word_chart_content);
        wordchart_content.setOption(wordoption_content);
        // 位置词云
        let wordata_poi = [];
        for(let i = 0; i　< worddata.note_poi_keywords.x_names.length; i++) {
          let ndic = { name: worddata.note_poi_keywords.x_names[i], value: worddata.note_poi_keywords.y_vales[0][i]};
          wordata_poi.push(ndic);
        }
        let wordoption_poi = {
          series: [
            {
              data: wordata_poi,
              type: 'wordCloud',
              shape: "smooth",
              sizeRange: [25, 80],
              textStyle:  {
                color() {
                  let colors = ['#396AF2', '#F5a20A', '#F52c9b', '#52C1D0', '#F23939']
                  return colors[parseInt(Math.random() * 5)]
                }
              },
            }
          ]
        }
        let wordchart_poi = echarts.init(this.$refs.word_chart_poi);
        wordchart_poi.setOption(wordoption_poi);
      }).catch((res) => {
        console.log("..fail: ", res);
      })
    }
  },
  mounted () {
    console.dir(this.$cookies);
    if (this.$cookies.get('UserToken')) {
      this.getListData();
    } else {
      console.dir('退出登录');
      this.clickLogout ();
    }
  },
  metaInfo: {
    title: "袤-AI数据挖掘系统",
    meta: [
      { name: "viewport", content: "width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0" },
      { name: "keywords", content: "袤周-大数据驱动下的智慧种草平台" },
      { name: "description", content: "袤周-大数据驱动下的智慧种草平台" },
      { name: "format-detection", content: "telephone=no,email=no" }
    ],
    link: [{
      rel: 'shortcut icon',
      href: '/static/favicon.ico'
    }]
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '../comm/css/base.styl'
.main_view
  height 100vh
  -webkit-overflow-scrolling touch
  background-color $brand-bgm
  display flex
  flex-direction column
  width 100%
  overflow-y scroll
  overflow-x hidden
  .report_head
    position absolute
    left 0
    top 0
    width 100%
    z-index 1
    background-color $white
    height 75px
    box-shadow 0 1px 8px 0 rgba(0,0,0,0.1)
    .report_head_item
      width 1000px
      height 75px
      display flex
      margin 0 auto
      flex-direction row
      align-items center
      justify-content space-between
      .report_head_right
        width auto
        display flex
        position relative
        height 75px
        flex-direction row
        align-items center
        .item_right
          width auto
          display flex
          position relative
          height 75px
          flex-direction row
          align-items center
          .img_head
            height 32px
            border-radius 50px
            width 32px
          .logout
            position absolute
            width 120px
            height 38px
            display flex;
            flex-direction column
            align-items center
            justify-content center
            color $white
            cursor pointer
            z-index 1
            right 0
            top 60px
            font-size 14px
            background $grey
          .nick_name
            color $color-two
            font-size 14px
            margin-left 10px
      .report_head_left
        width auto
        display flex
        flex-direction row
        align-items center
        height auto
        .note
          margin-left 15px
          color $color-two
          font-size 20px
          font-weight bold;
          width auto
          display flex
          position relative
          height 75px
          flex-direction row
          align-items center
        .line
          margin-left 10px
          width 1px
          height 57px
          background-color $colorE
        .report_info
          height auto
          display flex
          flex-direction column
          img
            height auto


  .report_home
    display flex
    flex-direction row
    justify-content center
    margin 0 auto
    margin-top 90px
    width 1000px
    .shop
      display flex
      flex-direction row
      width 100%
      .report_list
        display flex
        width 100%
        flex-direction column
        .report_item_head
          display flex
          margin-top 15px
          margin-bottom 15px
          width 100%
          align-items center
          justify-content center
          flex-direction row
          .report_item_value
            height 30px
            width auto
            line-height 30px
            margin-right 40px
            font-size 12px
            cursor pointer
            color $color-six
            &.selected
              border-bottom solid 3px $brand-blue
              font-weight bold
              color $brand-blue
              font-size 14px

  .report_item
    display flex
    flex-direction column
    margin 0 auto
    width 1000px
    height auto
    .head_item
      margin-top 10px
      height 30px
      display flex
      position relative
      align-items center
      color #111
      font-size 16px
    .report
      width 100%
      border-radius 12px
      height auto
      background-color $white
      display flex
      flex-direction row
      &.show_item
        padding-top 10px
        background-color $brand-bgm
        flex-wrap wrap
      .show_child_item
        display flex
        margin-bottom 5px
        width 240px
        border-radius 12px
        height 150px
        justify-content center
        align-content center
        align-items center
        flex-direction column
        background-color $white
        margin-right 10px
        .name
          color $brand-blue
          font-size 24px
        .note
          margin-top 5px
          font-size 12px
          font-weight inherit
          color $brand-gray

  .report_echarts_double
    display flex
    flex-direction row
    margin 0 auto
    height auto
    .report_echarts_one
      width 490px
      .echarts_head
        margin-top 10px
        margin-bottom 10px
        height 30px
        display flex
        position relative
        align-items center
        color #111
        font-size 16px
      .echarts_map
        border-radius 12px
        width 100%
        height 300px
        background-color $white
    .report_echarts_two
      width 490px
      margin-left 20px
      .echarts_head
        margin-top 10px
        margin-bottom 10px
        height 30px
        display flex
        position relative
        align-items center
        color #111
        font-size 16px
      .echarts_map
        border-radius 12px
        width 100%
        height 300px
        background-color $white

  .report_echarts
    display flex
    flex-direction column
    margin 0 auto
    margin-bottom 20px
    width 1000px
    height auto
    .echarts_head
      margin-top 10px
      margin-bottom 10px
      height 30px
      display flex
      position relative
      align-items center
      color #111
      font-size 16px
    .echarts_map
      border-radius 12px
      width 100%
      height 500px
      background-color $white

  .report_trend
    display flex
    flex-direction row
    margin 0 auto
    height auto
    .report_echarts_one
      width 490px
      .echarts_head
        margin-top 10px
        margin-bottom 10px
        height 30px
        display flex
        position relative
        align-items center
        color #111
        font-size 16px
      .echarts_map
        border-radius 12px
        width 100%
        height 300px
        background-color $white
    .report_echarts_two
      width 490px
      margin-left 20px
      .echarts_head
        margin-top 10px
        margin-bottom 10px
        height 30px
        display flex
        position relative
        align-items center
        color #111
        font-size 16px
      .echarts_map
        border-radius 12px
        width 100%
        height 300px
        background-color $white

.bottom_div
  background linear-gradient(135deg,rgba(51,51,51,1) 0%,rgba(17,17,17,1) 100%)
  width 100%
  height auto
  padding-top 20px
  padding-bottom 20px
  display flex
  color $white
  justify-content: center
  flex-direction row
  align-items center
  a
    margin-left: 10px
    margin-top 20px
    margin-bottom 20px
    color $white
</style>



// WEBPACK FOOTER //
// src/components/bigdata/BigdataNote.vue